import "core-js/modules/es.error.cause.js";
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-59077d9a"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "container"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "common-config"
}, "公共配置", -1));
const _hoisted_3 = {
  class: "dialog-footer"
};
import { ref, onMounted } from 'vue';
import { ElMessage } from 'element-plus';
import { getWjConfigDetail, getWjTypeList, saveOrUpdWjConfig } from '@/api/tenant';
export default {
  __name: 'WjCOnfig',
  setup(__props, {
    expose: __expose
  }) {
    const dialogVisible = ref(false);
    const clinicId = ref('');
    const tenantId = ref('');
    const form = ref({
      type: '',
      jsonValue: {
        code: '',
        http: true,
        ip: '',
        name: '',
        port: '',
        taxpayer: '',
        taxpayerNo: '',
        area: '',
        institutionKey: '',
        // 卓健全民健康
        appKey: '',
        appSecret: '',
        // 南海区
        account: '',
        orgCode: '',
        passWord: ''
      }
    });
    const wjTypeList = ref([]);
    async function _getWjTypeList() {
      const res = await getWjTypeList();
      wjTypeList.value = res;
    }
    onMounted(() => {
      _getWjTypeList();
    });
    async function saveOrUd(_tenantId, _clinicId) {
      clinicId.value = _clinicId;
      tenantId.value = _tenantId;
      const res = await getWjConfigDetail({
        tenantId: _tenantId,
        clinicId: _clinicId
      });
      if (res) {
        form.value = JSON.parse(JSON.stringify(res));
      } else {
        form.value = {
          type: '',
          jsonValue: {
            code: '',
            http: true,
            ip: '',
            name: '',
            port: '',
            taxpayer: '',
            taxpayerNo: '',
            area: '',
            institutionKey: '',
            // 卓健全民健康
            appKey: '',
            appSecret: '',
            // 南海区
            account: '',
            orgCode: '',
            passWord: ''
          }
        };
      }
      console.log('res', res);
      dialogVisible.value = true;
    }
    __expose({
      saveOrUd
    });
    const ruleFormRef = ref(null);
    const submitHandler = async () => {
      if (!form.value) return;
      const res = await ruleFormRef.value.validate();
      console.log(res, 'res');
      await saveOrUpdWjConfig({
        ...form.value,
        tenantId: tenantId.value,
        clinicId: clinicId.value
      });
      ElMessage({
        message: `${form.value.id ? '修改' : '新增'}成功`,
        type: 'success'
      });
      dialogVisible.value = false;
      setTimeout(() => {
        resetForm();
      });
    };
    const resetForm = () => {
      var _ruleFormRef$value;
      (_ruleFormRef$value = ruleFormRef.value) === null || _ruleFormRef$value === void 0 || _ruleFormRef$value.resetFields();
      form.value = {
        type: '',
        jsonValue: {
          code: '',
          http: true,
          ip: '',
          name: '',
          port: '',
          taxpayer: '',
          taxpayerNo: '',
          area: '',
          institutionKey: '',
          // 卓健全民健康
          appKey: '',
          appSecret: '',
          // 南海区
          account: '',
          orgCode: '',
          passWord: ''
        }
      };
    };
    return (_ctx, _cache) => {
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_checkbox = _resolveComponent("el-checkbox");
      const _component_el_form = _resolveComponent("el-form");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_dialog = _resolveComponent("el-dialog");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_dialog, {
        modelValue: dialogVisible.value,
        "onUpdate:modelValue": _cache[16] || (_cache[16] = $event => dialogVisible.value = $event),
        title: `${form.value.id ? '修改' : '新增'}配置`,
        "destroy-on-close": "",
        class: "dialog-class flex flex-column justify-center",
        onClosed: _cache[17] || (_cache[17] = $event => _ctx.$emit('clearModel')),
        "close-on-click-modal": false
      }, {
        footer: _withCtx(() => [_createElementVNode("span", _hoisted_3, [_createVNode(_component_el_button, {
          onClick: _cache[15] || (_cache[15] = $event => dialogVisible.value = false)
        }, {
          default: _withCtx(() => [_createTextVNode(" 取消 ")]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          onClick: submitHandler
        }, {
          default: _withCtx(() => [_createTextVNode(" 确认 ")]),
          _: 1
        })])]),
        default: _withCtx(() => [_createVNode(_component_el_form, {
          "label-width": "120px",
          "status-icon": "",
          model: form.value,
          ref_key: "ruleFormRef",
          ref: ruleFormRef
        }, {
          default: _withCtx(() => {
            var _form$value$jsonValue2;
            return [_createVNode(_component_el_form_item, {
              label: "方案选择",
              prop: "type",
              required: true,
              rules: [{
                validator: (rule, value, callback) => {
                  if (!form.value.type) {
                    return callback(new Error('请选择'));
                  }
                  callback();
                }
              }]
            }, {
              default: _withCtx(() => [_createVNode(_component_el_select, {
                modelValue: form.value.type,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => form.value.type = $event),
                style: {
                  "width": "400px"
                }
              }, {
                default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(wjTypeList.value, item => {
                  return _openBlock(), _createBlock(_component_el_option, {
                    key: item.code,
                    label: item.name,
                    value: item.code
                  }, null, 8, ["label", "value"]);
                }), 128))]),
                _: 1
              }, 8, ["modelValue"])]),
              _: 1
            }, 8, ["rules"]), _hoisted_2, _createVNode(_component_el_form_item, {
              label: "机构名称",
              prop: "jsonValue.name",
              required: true,
              rules: [{
                validator: (rule, value, callback) => {
                  var _form$value$jsonValue;
                  console.log(value);
                  if (!((_form$value$jsonValue = form.value.jsonValue) !== null && _form$value$jsonValue !== void 0 && _form$value$jsonValue.name)) {
                    return callback(new Error('请输入机构名称'));
                  }
                  callback();
                }
              }]
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                style: {
                  "width": "400px"
                },
                modelValue: form.value.jsonValue.name,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => form.value.jsonValue.name = $event),
                placeholder: "机构名称"
              }, null, 8, ["modelValue"])]),
              _: 1
            }, 8, ["rules"]), _createVNode(_component_el_form_item, {
              label: "机构注册码",
              prop: "jsonValue.code",
              required: true,
              rules: [{
                validator: (rule, value, callback) => {
                  console.log(value);
                  if (!form.value.jsonValue.code) {
                    return callback(new Error('请输入机构注册码'));
                  }
                  callback();
                }
              }]
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                style: {
                  "width": "400px"
                },
                modelValue: form.value.jsonValue.code,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => form.value.jsonValue.code = $event),
                placeholder: "机构注册码"
              }, null, 8, ["modelValue"])]),
              _: 1
            }, 8, ["rules"]), _createVNode(_component_el_form_item, {
              label: "服务器地址",
              prop: "jsonValue.ip",
              required: true,
              rules: [{
                validator: (rule, value, callback) => {
                  console.log(value);
                  if (!form.value.jsonValue.ip) {
                    return callback(new Error('请输入服务器地址'));
                  }
                  callback();
                }
              }]
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                style: {
                  "width": "150px"
                },
                modelValue: form.value.jsonValue.ip,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => form.value.jsonValue.ip = $event),
                placeholder: "服务器地址"
              }, null, 8, ["modelValue"]), _createVNode(_component_el_form_item, {
                label: "端口",
                "label-width": "60px",
                prop: "jsonValue.port"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  style: {
                    "width": "80px"
                  },
                  modelValue: form.value.jsonValue.port,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => form.value.jsonValue.port = $event),
                  placeholder: "端口"
                }, null, 8, ["modelValue"])]),
                _: 1
              }), _createVNode(_component_el_form_item, {
                "label-width": "20px",
                prop: "jsonValue.http"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_checkbox, {
                  modelValue: form.value.jsonValue.http,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => form.value.jsonValue.http = $event),
                  label: "HTTP方式",
                  size: "large"
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            }, 8, ["rules"]), _createVNode(_component_el_form_item, {
              label: "纳税人",
              prop: "jsonValue.taxpayer"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                style: {
                  "width": "400px"
                },
                modelValue: form.value.jsonValue.taxpayer,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => form.value.jsonValue.taxpayer = $event),
                placeholder: "纳税人"
              }, null, 8, ["modelValue"])]),
              _: 1
            }), _createVNode(_component_el_form_item, {
              label: "纳税号",
              prop: "jsonValue.taxpayerNo"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                style: {
                  "width": "400px"
                },
                modelValue: form.value.jsonValue.taxpayerNo,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => form.value.jsonValue.taxpayerNo = $event),
                placeholder: "纳税号"
              }, null, 8, ["modelValue"])]),
              _: 1
            }), form.value.type === 2 ? (_openBlock(), _createElementBlock(_Fragment, {
              key: 0
            }, [_createVNode(_component_el_form_item, {
              label: "所属城区",
              prop: "jsonValue.area",
              required: true,
              rules: [{
                validator: (rule, value, callback) => {
                  console.log(value);
                  if (!form.value.jsonValue.area) {
                    return callback(new Error('请选择所属城区'));
                  }
                  callback();
                }
              }]
            }, {
              default: _withCtx(() => [_createVNode(_component_el_select, {
                style: {
                  "width": "400px"
                },
                modelValue: form.value.jsonValue.area,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => form.value.jsonValue.area = $event),
                placeholder: "所属城区"
              }, {
                default: _withCtx(() => [(_openBlock(), _createElementBlock(_Fragment, null, _renderList([{
                  id: 1,
                  label: '西湖区',
                  value: 'xiHu'
                }, {
                  id: 2,
                  label: '上城区',
                  value: 'sc'
                }], item => {
                  return _createVNode(_component_el_option, {
                    key: item.value,
                    label: item.label,
                    value: item.value
                  }, null, 8, ["label", "value"]);
                }), 64))]),
                _: 1
              }, 8, ["modelValue"])]),
              _: 1
            }, 8, ["rules"]), ((_form$value$jsonValue2 = form.value.jsonValue) === null || _form$value$jsonValue2 === void 0 ? void 0 : _form$value$jsonValue2.area) === 'sc' ? (_openBlock(), _createBlock(_component_el_form_item, {
              key: 0,
              label: "机构密钥",
              prop: "jsonValue.institutionKey"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                style: {
                  "width": "400px"
                },
                modelValue: form.value.jsonValue.institutionKey,
                "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => form.value.jsonValue.institutionKey = $event),
                placeholder: "机构密钥"
              }, null, 8, ["modelValue"])]),
              _: 1
            })) : _createCommentVNode("", true)], 64)) : _createCommentVNode("", true), form.value.type === 3 ? (_openBlock(), _createElementBlock(_Fragment, {
              key: 1
            }, [_createVNode(_component_el_form_item, {
              label: "账号",
              prop: "jsonValue.account"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                style: {
                  "width": "400px"
                },
                modelValue: form.value.jsonValue.account,
                "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => form.value.jsonValue.account = $event),
                placeholder: "账号"
              }, null, 8, ["modelValue"])]),
              _: 1
            }), _createVNode(_component_el_form_item, {
              label: "机构id",
              prop: "jsonValue.orgCode"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                style: {
                  "width": "400px"
                },
                modelValue: form.value.jsonValue.orgCode,
                "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => form.value.jsonValue.orgCode = $event),
                placeholder: "机构id"
              }, null, 8, ["modelValue"])]),
              _: 1
            }), _createVNode(_component_el_form_item, {
              label: "密码",
              prop: "jsonValue.passWord"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                style: {
                  "width": "400px"
                },
                modelValue: form.value.jsonValue.passWord,
                "onUpdate:modelValue": _cache[12] || (_cache[12] = $event => form.value.jsonValue.passWord = $event),
                placeholder: "密码"
              }, null, 8, ["modelValue"])]),
              _: 1
            })], 64)) : _createCommentVNode("", true), form.value.type === 4 || form.value.type === 5 ? (_openBlock(), _createElementBlock(_Fragment, {
              key: 2
            }, [_createVNode(_component_el_form_item, {
              label: "AppKey",
              prop: "jsonValue.appKey"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                style: {
                  "width": "400px"
                },
                modelValue: form.value.jsonValue.appKey,
                "onUpdate:modelValue": _cache[13] || (_cache[13] = $event => form.value.jsonValue.appKey = $event),
                placeholder: "AppKey"
              }, null, 8, ["modelValue"])]),
              _: 1
            }), _createVNode(_component_el_form_item, {
              label: "AppSecret",
              prop: "jsonValue.appSecret"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                style: {
                  "width": "400px"
                },
                modelValue: form.value.jsonValue.appSecret,
                "onUpdate:modelValue": _cache[14] || (_cache[14] = $event => form.value.jsonValue.appSecret = $event),
                placeholder: "AppSecret"
              }, null, 8, ["modelValue"])]),
              _: 1
            })], 64)) : _createCommentVNode("", true)];
          }),
          _: 1
        }, 8, ["model"])]),
        _: 1
      }, 8, ["modelValue", "title"])]);
    };
  }
};